<script lang="ts" setup>
const { articles: sortedArticles } = await useSupportArticles()
</script>

<template>
  <section class="support-index">
    <ul class="cards">
      <li v-for="article of sortedArticles" :key="article.path">
        <NuxtLink class="card" :to="article.path">
          <span class="icon"><SbIcon :name="article.icon ?? 'info'" size="28px" /></span>
          <span class="title">{{ article.title }}</span>
          <span v-if="article.description" class="description">{{ article.description }}</span>
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.support-index {
  max-width: 1000px;
  margin-top: 40px;
  margin-inline: auto;
  padding: 0 20px;
}

.cards {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

// Make each grid cell a flex container so its card stretches to the full cell height
.cards > li {
  display: flex;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid var(--border-subtle);
  background: var(--background-subtle);
  text-decoration: none;
  color: var(--text);
  transition:
    border-color 120ms ease,
    transform 120ms ease;

  &:hover {
    border-color: var(--border-highlight);
    transform: translateY(-2px);
  }
}

.icon {
  color: var(--primary);
  margin-bottom: 4px;
}

.title {
  font-size: 1.15em;
  font-weight: bold;
}

.description {
  color: var(--text-subtle);
  font-size: 0.95em;
  line-height: 1.5;
}
</style>
